import { render, staticRenderFns } from "./PersonCostDetailDialog.vue?vue&type=template&id=38fd46bc&scoped=true&"
import script from "./PersonCostDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PersonCostDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PersonCostDetailDialog.vue?vue&type=style&index=0&id=38fd46bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd46bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38fd46bc')) {
      api.createRecord('38fd46bc', component.options)
    } else {
      api.reload('38fd46bc', component.options)
    }
    module.hot.accept("./PersonCostDetailDialog.vue?vue&type=template&id=38fd46bc&scoped=true&", function () {
      api.rerender('38fd46bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/components/PersonCostDetailDialog.vue"
export default component.exports